export default "__VITE_PUBLIC_ASSET__13d8fa23__"